export enum UserTypes {
  All = 0,
  Student = 1,
  Tutor = 2,
  AdminTutor = 3,
  AdminExitAndEntry = 4,
  Owner = 5,
  Admin = 9,
}

export function getUserTypeName(value: UserTypes): string {
  switch (value) {
    case UserTypes.All: return 'すべて';
    case UserTypes.Student: return '生徒';
    case UserTypes.Tutor: return '講師';
    case UserTypes.AdminTutor: return '管理者講師';
    case UserTypes.AdminExitAndEntry: return '入退室管理システム';
    case UserTypes.Owner: return 'オーナー';
    case UserTypes.Admin: return '管理者';
  }
}

export function getUserTypeFromString(value: string): UserTypes {
  switch (value.toLowerCase()) {
    case 'student': return UserTypes.Student;
    case 'tutor': return UserTypes.Tutor;
    case 'admintutor': return UserTypes.AdminTutor;
    case 'adminexitandentry': return UserTypes.AdminExitAndEntry;
    case 'owner': return UserTypes.Owner;
    case 'admin': return UserTypes.Admin;
    default: return UserTypes.All;
  }
}
